<template>
    <v-parallax
        height="450"
        cover
        src="@/assets/img/parallax.jpeg"
        class="home-parallax"
    >
      <v-row >
        <v-col cols="12" class="text-center pt-12" >
          <img
              class="logo-home"
              :style="{width:getWidth}"
               src="@/assets/img/LogoTremendas7.png"
          />
        </v-col>
        <v-col cols="12" >
          <home-data></home-data>
        </v-col>
      </v-row>


    </v-parallax>
</template>

<script>
import HomeData from "@/modules/base/pages/HomePage/HomeData";
export default {
  name: "HomeParallax",
  components: {HomeData},
  computed: {
    getWidth(){
      if(this.$vuetify.breakpoint.xsOnly){
        return '90%'
      }
      if(this.$vuetify.breakpoint.smOnly){
        return '80%'
      }
      if(this.$vuetify.breakpoint.xlOnly){
        return '30%'
      }
      return '40%'
    }
  }
}
</script>

<style scoped>


.home-parallax {
  width: 100% !important;
  height: 600px !important;
}

.logo-home {
  background-position: center;
}
</style>
